import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "./LanguageContext";
import { Reveal } from "./Reveal";
import { TRX_URL } from "./content";

export const HowItWorks = () => {
  const { t } = useLang();

  return (
    <section id="how" className="relative py-24 md:py-32 border-t border-white/10 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="max-w-3xl mb-16">
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#ccff00]">
              {t.how.overline}
            </span>
            <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight text-white mt-4 leading-tight">
              {t.how.title}
            </h2>
          </div>
        </Reveal>

        <div className="divide-y divide-white/10 border-y border-white/10">
          {t.how.steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.08 }}
              data-testid={`step-${step.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 items-center gap-4 py-10 md:py-14 hover:bg-white/[0.02] transition-colors px-2 md:px-6"
            >
              <div className="md:col-span-3 font-display font-black text-6xl md:text-8xl text-transparent [-webkit-text-stroke:1.5px_rgba(255,255,255,0.35)] group-hover:[-webkit-text-stroke:1.5px_rgba(204,255,0,0.8)] transition-all">
                {step.n}
              </div>
              <h3 className="md:col-span-4 font-display font-semibold text-2xl md:text-3xl text-white tracking-tight">
                {step.title}
              </h3>
              <p className="md:col-span-5 text-zinc-400 font-light text-base md:text-lg leading-relaxed">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 flex justify-start">
            <a
              href={TRX_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="how-cta-btn"
              className="group inline-flex items-center gap-3 h-14 px-8 bg-[#ccff00] text-black font-bold text-sm tracking-wide hover:bg-[#b3e600] transition-colors"
            >
              {t.cta.start}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
